import { columnType } from "DataTypes/Table";
import ControlledTable from "Components/ControlledTable";
import { DropdownArrPropsType } from "DataTypes/Form";

export type PatientCaseListType = {
  id: string;
  internalCaseId: number | null;
  patientCaseId: string;
  status: string;
  subject: string;
  patientCaseType: string;
  description: string;
  caseCreatedDate: string;
  dateTime: string;
  externalSystem: string;
};

export const PriorityDropArr: DropdownArrPropsType[] = [
  { id: 1, label: "1 - High", value: "1" }, { id: 2, label: "2 - Medium", value: "2" }, { id: 3, label: "3 - Low", value: "3" },
];
export const DocumentSourceDropArr: DropdownArrPropsType[] = ["PATIENT", "CAREGIVER", "PARTNER", "PHARMACY", "LAB", "PCP", "SPECIALIST", "STAFF", "HOSPITAL", "OTHER"].map((value, i) => ({ id: i + 1, label: value, value }));
export const DocumentSubclassDropArr: DropdownArrPropsType[] = ["PATIENTCASE", "ADMINISTRATIVE", "BILLING", "CLINICALQUESTION", "ELECTRONICMEDICALRECORDS", "MEDICALRECORDS", "MEDICATION", "NEWRX", "OTHER", "PATIENTNOSHOW", "REFERRAL", "REFILL"].map((value, i) => ({ id: i + 1, label: value, value }));

export const TableCol: (rowClick: (data: any) => void) => columnType[] = (
  rowClick
) => [
  ControlledTable.ColumnData.DateTimeCol1("15%"),
  ControlledTable.ColumnData.TaskTypeCol("10%"),
  {
    id: "status",
    label: "Status",
    width: "10%",
    align: "center",
    colType: "text",
    rowType: "status",
    rowClick,
  },
  ControlledTable.ColumnData.PriorityCol("10%"),
  ControlledTable.ColumnData.AssigneeCol("15%"),
  ControlledTable.ColumnData.SubjectCol("20%"),
  ControlledTable.ColumnData.NoteCol("20%"),
];

export const VisitsTabelCol: columnType[] = [
  ControlledTable.ColumnData.VisitNumCol(),
  ControlledTable.ColumnData.FacilityCol(),
  ControlledTable.ColumnData.ReasonCol(),
  ControlledTable.ColumnData.DateTimeCol1(),
];

export const PatientCaseTableCol: columnType[] = [
  { id: "dateTime", label: "Date & Time", width: "15%", align: "center", colType: "text", rowType: "date" },
  { id: "patientCaseType", label: "Case Type", width: "15%", align: "center", colType: "text", rowType: "text" },
  { id: "status", label: "Status", width: "10%", align: "center", colType: "text", rowType: "status" },
  { id: "patientCaseId", label: "Athena Case Id", width: "12%", align: "center", colType: "text", rowType: "text" },
  { id: "subject", label: "Subject", width: "20%", align: "left", colType: "text", rowType: "text" },
  { id: "description", label: "Notes", width: "28%", align: "left", colType: "text", rowType: "text" },
];
